import { render, staticRenderFns } from "./YKProjectSchedule.vue?vue&type=template&id=27cd0d1a&scoped=true&"
import script from "./YKProjectSchedule.vue?vue&type=script&lang=js&"
export * from "./YKProjectSchedule.vue?vue&type=script&lang=js&"
import style0 from "./YKProjectSchedule.vue?vue&type=style&index=0&id=27cd0d1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cd0d1a",
  null
  
)

export default component.exports